/** Treatment endings — ترک درمان / ترخیص (ZOY-723 / ZOY-724). */
export const treatmentFa: Record<string, string> = {
  'te.action': 'پایان درمان',
  'te.dialog.title': 'ثبت پایان درمان',
  'te.dialog.sub':
    'ترک درمان یا ترخیص را ثبت کنید. نوبت‌های آینده لغو می‌شوند و بسته‌ها متوقف می‌شوند.',
  'te.kind.label': 'نوع',
  'te.kind.dropout': 'ترک درمان',
  'te.kind.discharge': 'ترخیص',
  'te.scope.label': 'دامنه',
  'te.scope.patient': 'کل درمان',
  'te.scope.service': 'یک خدمت',
  'te.scope.package': 'یک بسته',
  'te.package': 'بسته',
  'te.service': 'خدمت',
  'te.choose': 'انتخاب',
  'te.reason': 'دلیل ترک درمان',
  'te.reason.cost': 'هزینه',
  'te.reason.distance_or_time': 'فاصله یا زمان',
  'te.reason.no_visible_progress': 'پیشرفت محسوسی نیست',
  'te.reason.dissatisfied_with_therapist': 'نارضایتی از درمانگر',
  'te.reason.moved_to_another_centre': 'انتقال به مرکز دیگر',
  'te.reason.relocation': 'جابه‌جایی محل سکونت',
  'te.reason.child_illness': 'بیماری کودک',
  'te.reason.family_circumstances': 'شرایط خانوادگی',
  'te.reason.other': 'سایر',
  'te.decidedBy.label': 'تصمیم گیرنده',
  'te.decidedBy.family': 'خانواده',
  'te.decidedBy.clinic': 'مرکز',
  'te.note': 'توضیح',
  'te.preview.title': 'ثبت این مورد چه می‌کند',
  'te.preview.bookings': 'نوبت‌های آینده‌ای که لغو می‌شوند: {n}',
  'te.preview.packages': 'بسته‌هایی که متوقف می‌شوند: {names}',
  'te.preview.noPackages': 'هیچ بسته‌ای متوقف نمی‌شود.',
  'te.preview.settled': 'حساب تسویه‌شده؛ این مورد بی درنگ نهایی می‌شود.',
  'te.preview.unsettled':
    'حساب تسویه نشده (بدهی {debt}، اعتبار {credit}). تا تسویه نشود در انتظار می‌ماند.',
  'te.confirm': 'ثبت',
  'te.cancel': 'انصراف',
  'te.notCancelled': '{n} نوبت لغو نشد و به بررسی دستی نیاز دارد.',
  'te.pending.title': 'پایان درمان در انتظار تسویه',
  'te.pending.body': '{what} ثبت شد اما هنوز نهایی نیست. اول حساب را تسویه کنید.',
  'te.pending.debt': 'مراجع بدهکار است: {amount}',
  'te.pending.credit': 'اعتبار نگه داشته شده توسط مرکز: {amount}',
  'te.pending.settled': 'حساب تسویه‌شده؛ می‌توانید نهایی کنید.',
  'te.pending.goPayments': 'پرداخت‌ها و بازپرداخت',
  'te.finalize': 'ثبت نهایی',
  'te.withdraw': 'لغو این ثبت',
  'te.withdraw.title': 'این ثبت پس‌گرفته شود؟',
  'te.withdraw.body': 'بسته‌های متوقف‌شده دوباره باز می‌شوند. نوبت‌های لغو شده برنمی‌گردند.',
  'te.final.dropout': 'ترک درمان',
  'te.final.discharge': 'ترخیص',
  'te.final.reason': 'دلیل: {reason}',
  'te.return': 'بازگشت بیمار',
  'te.return.title': 'مراجع بازگشته است',
  'te.return.body': 'درمان چطور ادامه یابد؟',
  'te.return.resume': 'ادامهٔ بستهٔ نیمه‌تمام',
  'te.return.resumeHelp': 'بسته‌های متوقف‌شده دوباره باز می‌شوند و نوبت‌دهی ادامه پیدا می‌کند.',
  'te.return.new': 'ارزیابی جدید و بسته جدید',
  'te.return.newHelp': 'بسته‌های قبلی متوقف می‌مانند و به ارزیابی مجدد می‌روید.',
  'te.scopeLabel.patient': 'کل درمان',
  'te.scopeLabel.service': 'خدمت {name}',
  'te.scopeLabel.package': 'بسته {name}',
  'te.err.notSettled': 'حساب هنوز تسویه نشده.',
  'te.err.alreadyOpen': 'برای این دامنه از قبل پایان درمان ثبت‌شده.',
  'te.err.generic': 'انجام نشد. دوباره تلاش کنید.',
  'te.cancelReason.dropout': 'ترک درمان — {reason}',
  'te.cancelReason.discharge': 'ترخیص',
  'te.stopped': 'متوقف‌شده',

  'py.refund.title': 'عودت وجه به بیمار',
  'py.refund.sub': 'اعتباری که مرکز برای این مراجع نگه داشته را برگردانید.',
  'py.refund.amount': 'مبلغ عودت',
  'py.refund.amountHelp': 'حداکثر {max}',
  'py.refund.from': 'از کدام اعتبار',
  'py.refund.fromAny': 'اعتبار عمومی، سپس بسته‌ها',
  'py.refund.cta': 'ثبت عودت',
  'py.refund.done': 'بازپرداخت ثبت شد.',
  'py.refund.errExceeds': 'بیشتر از اعتبار موجود (موجود: {max}).',
  'py.refund.histTitle': 'عودت‌های ثبت‌شده',
  'py.hist.errRefunded': 'بخشی از این پرداخت بازپرداخت شده، بنابراین دیگر قابل برگشت دادن نیست.',

  'te.cr.tab': 'ادامهٔ درمان',
  'te.cr.sub': 'دوره‌هایی که آخرین جلسه‌شان ۱۴ روز یا بیشتر پیش بوده و مراجعشان قدم بعدی برنداشته.',
  'te.cr.col.patient': 'مراجع',
  'te.cr.col.package': 'دوره',
  'te.cr.col.last': 'آخرین جلسه',
  'te.cr.col.days': 'روزهای گذشته',
  'te.cr.col.therapist': 'درمانگر',
  'te.cr.col.progress': 'جلسه‌ها',
  'te.cr.col.outcome': 'نتیجه',
  'te.cr.continuing': 'در حال ادامه',
  'te.cr.emptyTitle': 'چیزی برای پیگیری نیست',
  'te.cr.emptyBody': 'یک دوره تمام‌شده بدون قدم بعدی، بعد از ۱۴ روز این‌جا ظاهر می‌شود.',
  'te.cr.again': '«در حال ادامه» قبلا ثبت‌شده بود',
  'te.cr.ofPlanned': '{delivered} از {planned}',
};
